import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Modal } from '@figure/frontlib-gui';

const StyledBrowserTable = styled.table`
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    padding: 6px 13px;
    border: 1px solid #dfe2e5;
  }
`;

const BrowserSupportTable = () => (
  <StyledBrowserTable>
    <thead>
      <tr>
        <th align="right" />
        <th align="left">Chrome</th>
        <th align="left">Edge</th>
        <th align="left">Firefox</th>
        <th align="left">Safari</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td align="right">
          <strong>Android</strong>
        </td>
        <td align="left">✓</td>
        <td align="left">-</td>
        <td align="left">✓</td>
        <td align="left">-</td>
      </tr>
      <tr>
        <td align="right">
          <strong>iOS</strong>
        </td>
        <td align="left">-</td>
        <td align="left">-</td>
        <td align="left">-</td>
        <td align="left">✓</td>
      </tr>
      <tr>
        <td align="right">
          <strong>Linux</strong>
        </td>
        <td align="left">✓</td>
        <td align="left">-</td>
        <td align="left">✓</td>
        <td align="left">-</td>
      </tr>
      <tr>
        <td align="right">
          <strong>macOS</strong>
        </td>
        <td align="left">✓</td>
        <td align="left">-</td>
        <td align="left">✓</td>
        <td align="left">✓</td>
      </tr>
      <tr>
        <td align="right">
          <strong>Windows</strong>
        </td>
        <td align="left">✓</td>
        <td align="left">✓</td>
        <td align="left">✓</td>
        <td align="left">-</td>
      </tr>
    </tbody>
  </StyledBrowserTable>
);

const BrowserSupportModal = ({ isOpen, onClose }) => (
  <Modal header="Video connection error" size="sm" isOpen={isOpen} onClose={onClose}>
    <p>
      Electronic notary requires the use of your webcam and microphone. Please check browser
      compatibility and retry:
    </p>
    <BrowserSupportTable />
  </Modal>
);

BrowserSupportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BrowserSupportModal;
